<template>
  <v-app>
    <v-app-bar app flat color="white">
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="grey lighten-4 pt-14">
      <div class="container1400">
        <v-container fluid>
          <div class="mt-6">
            <v-skeleton-loader v-if="!list" type="article"></v-skeleton-loader>
            <v-alert dense outlined type="error" v-if="error">
              <ul>
                <li v-for="item in error" :key="item.msg">
                  {{ $t(item.msg) }}
                </li>
              </ul>
            </v-alert>
            <div v-if="list">
              <div class="pt-5">
                <h1 class="text-h4 font-weight-medium">{{ list.name }}</h1>
                <div class="subtitle-1 pt-3 text-capitalize">
                  <span>
                    <v-icon small color="light-blue"
                      >mdi-map-marker-radius</v-icon
                    >
                    {{ list.location }}
                  </span>
                </div>
                <div
                  class="subtitle-1 pt-3 text-capitalize font-weight-regular grey--text text--darken-4"
                >
                  <span class="light-blue--text text--darken-4"
                    >{{ $t("Type") }}:</span
                  >
                  {{ $t(list.type) }}
                  <span class="light-blue--text text--darken-4 pl-5">
                    {{ $t("Category") }}:</span
                  >
                  {{ $t(list.category) }}
                  <v-avatar class="mr-2 ml-5" color="light-blue" size="24">
                    <span class="white--text subtitle-2">{{
                      list.no_rooms
                    }}</span> </v-avatar
                  >{{ $tc("Room", 2) }}
                  <v-avatar class="ml-5 mr-2" color="light-blue" size="24">
                    <span class="white--text subtitle-2">{{
                      list.no_bathrooms
                    }}</span> </v-avatar
                  >{{ $tc("Bathroom", 2) }}
                </div>
              </div>
              <v-row>
                <v-col cols="12" md="8">
                  <v-sheet
                    color="light-blue"
                    height="480px"
                    v-if="!list.pictures"
                  >
                    <v-row class="fill-height" align="center" justify="center">
                      <div class="display-3">NO Images</div>
                    </v-row>
                  </v-sheet>
                  <v-carousel
                    hide-delimiters
                    class="mt-5 mb-5"
                    height="480"
                    v-if="list.pictures"
                  >
                    <v-carousel-item
                      v-for="(item, i) in list.pictures"
                      :key="i"
                      :src="
                        $store.state.baseUrl +
                          'listing/thumb800x480-' +
                          item.file_name
                      "
                    >
                      <div v-if="item.caption" class="cap text-capitalize">
                        {{ item.caption }}
                      </div>
                    </v-carousel-item>
                  </v-carousel>
                  <v-row>
                    <v-col>
                      <h2 class="text-h6 font-weight-medium text-left">
                        {{ list.teaser }}
                      </h2>
                      <div class="body-1 pt-3" v-html="list.description">
                        {{ list.description }}
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col md="4" cols="12">
                  <VideoTourDialog
                    v-if="video_url.length || videos.length"
                    :yData="video_url"
                    :vData="videos"
                  />
                  <v-card elevation="1" class="ml-md-5 mt-5 pa-5 mx-auto">
                    <div>
                      <span class="grey--text">{{ currency_code }} </span>
                      <span
                        class="text-h6 light-blue--text text--darken-4 font-weight-bold"
                        >{{ list.price }}
                      </span>
                      <span class="grey--text"> / {{ $t("Night") }}</span>
                    </div>
                    <div class="subtitle-2 pt-2">
                      {{ $t("AMaximumOf") }} {{ list.no_guests }}
                      <span v-if="list.no_guests == 1">
                        {{ $tc("Adult", 1) }}</span
                      >
                      <span v-if="list.no_guests > 1">
                        {{ $tc("Adult", 2) }}</span
                      >, {{ list.no_childrens }}
                      <span> {{ $tc("Children", 2) }}</span>
                    </div>
                    <PriceSectionComponent
                      v-if="
                        !list.contract ||
                          (list.contract && list.contract.active)
                      "
                    />
                    <v-alert
                      class="mt-3"
                      dense
                      outlined
                      type="error"
                      v-if="list.contract && !list.contract.active"
                      >{{ $t("CP2") }}
                    </v-alert>
                    <v-dialog
                      v-model="dialog"
                      scrollable
                      max-width="600px"
                      width="100%"
                      persistent
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div class="text-center">
                          <v-btn
                            color="light-blue"
                            text
                            v-bind="attrs"
                            v-on="on"
                            >{{ $t("CP") }}</v-btn
                          >
                        </div>
                      </template>
                      <v-card class="pb-10">
                        <v-card-title class="light-blue darken-4 white--text">
                          {{ $t("CP") }}
                          <v-spacer></v-spacer>
                          <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" class="pb-0">
                              <div class="overline text-left">
                                {{ $t("PM61") }}
                              </div>
                              <div class="subtitle-2">
                                {{ $t("BufferPeriod") }}:
                                {{ list.short_term_buffer * 3 }}
                                {{ $t("Days") }}
                              </div>
                              <div class="overline text-left pt-4">
                                {{ $t("PM71") }}
                              </div>
                              <div class="subtitle-2">
                                {{ $t("BufferPeriod") }}:
                                {{ list.long_term_buffer * 15 }}
                                {{ $t("Days") }}
                              </div>
                              <div class="subtitle-2 pt-4 red--text">
                                {{ $t("PM8") }}
                              </div>
                              <div class="text-center">
                                <a
                                  target="_blank"
                                  href="https://member.nomadrooms.com/terms/cancellation/"
                                  @click.stop
                                >
                                  {{ $t("CP1") }}
                                </a>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-card>
                  <v-card
                    color="white"
                    elevation="1"
                    class="ml-md-5 mt-5 mx-auto pa-5"
                  >
                    <h2 class="text-h6 font-weight-medium text-left">
                      {{ $t("Houserules") }}
                    </h2>
                    <div
                      v-if="list.age_restriction"
                      class="overline text-left grey--text"
                    >
                      {{ $t(`s1655921125`) }}
                      <span>
                        <v-chip class="mr-1 mb-1" small dark color="light-blue">
                          {{ list.age_restriction }}
                        </v-chip>
                      </span>
                    </div>
                    <div class="overline text-left grey--text">
                      {{ $t("CheckInTimes") }}
                    </div>
                    <div>
                      <span v-for="value in list.check_in_times" :key="value">
                        <v-chip class="mr-1 mb-1" small dark color="light-blue">
                          {{ value }}
                        </v-chip>
                      </span>
                    </div>
                    <div class="overline pt-3 text-left grey--text">
                      {{ $t("CheckOutTimes") }}
                    </div>
                    <div class="text-left">
                      <span v-for="value in list.check_out_times" :key="value">
                        <v-chip class="mr-1 mb-1" small dark color="light-blue">
                          {{ value }}
                        </v-chip>
                      </span>
                    </div>
                    <h2
                      v-if="list.rules && list.rules.length"
                      class="pt-5 text-h6 font-weight-medium text-left"
                    >
                      {{ $t("Restrictions") }}
                    </h2>
                    <p
                      class="mb-0 pt-2 subtitle-2"
                      v-for="(field, i) in list.rules"
                      :key="i"
                    >
                      {{ $t(field) }}
                    </p>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="basic_amenities.length">
                <v-col>
                  <h2 class="text-h6 font-weight-medium text-left">
                    {{ $t("AmenitiesOf") }} {{ list.name }}
                  </h2>
                  <v-row>
                    <v-col
                      cols="2"
                      v-for="(item, i) in basic_amenities"
                      :key="i"
                    >
                      <h3 class="overline text-left grey--text">
                        {{ $t(item.title) }}
                      </h3>
                      <v-divider></v-divider>
                      <p
                        class="subtitle-2 mb-0 mt-2"
                        v-for="field in item.data"
                        :key="field._id"
                      >
                        {{ $t(field.ln_key) }}
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <l-map
                    :zoom="15"
                    :center="[list.position[1], list.position[0]]"
                    style="width: 100%; height: 400px"
                  >
                    <l-tile-layer :url="url" :attribution="attribution" />
                    <l-marker :lat-lng="[list.position[1], list.position[0]]">
                    </l-marker>
                  </l-map>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" v-if="near_attractions.length">
                  <v-card flat min-height="100%">
                    <v-card-text class="pa-5">
                      <h2 class="text-h6 pb-3 font-weight-medium text-left">
                        {{ $t("NearByAttractions") }}
                      </h2>
                      <ul v-for="value in near_attractions" :key="value.place">
                        <li>
                          {{ value.place }} - {{ value.distance }} Miles
                          {{ $t("away") }}
                        </li>
                      </ul>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" v-if="list.property_route">
                  <v-card flat min-height="100%">
                    <v-card-text class="pa-5">
                      <h2 class="text-h6 pb-3 font-weight-medium text-left">
                        {{ $t("HowToGetThere") }}
                      </h2>
                      <div class="subtitle-2" v-html="list.property_route">
                        {{ list.property_route }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <div v-if="review" class="mx-auto mt-10" style="max-width: 900px">
                <h2 class="text-h6 pb-0 font-weight-medium text-left">
                  {{ review.count }}
                  {{ $t("Reviews") }}
                </h2>
                <p class="pb-5 mb-0">
                  {{ $t("string620") }} : {{ review.overallAvg }} / 5
                </p>
                <v-card elevation="0" class="mb-5">
                  <v-card-text>
                    <table style="width: 100%">
                      <tr>
                        <td class="pb-5" style="width: 200px">
                          <div class="overline grey--text mr-5">
                            {{ $t("rating1") }} :
                          </div>
                        </td>
                        <td class="pb-5">
                          <v-rating
                            dense
                            background-color="grey lighten-1"
                            color="light-blue"
                            hover
                            length="5"
                            readonly
                            v-model="review.rating1Avg"
                          ></v-rating>
                        </td>
                        <td class="pb-5" style="width: 200px">
                          <div class="overline grey--text mr-5">
                            {{ $t("rating2") }} :
                          </div>
                        </td>
                        <td class="pb-5">
                          <v-rating
                            dense
                            background-color="grey lighten-1"
                            color="light-blue"
                            hover
                            length="5"
                            readonly
                            v-model="review.rating2Avg"
                          ></v-rating>
                        </td>
                      </tr>
                      <tr>
                        <td class="pb-5">
                          <div class="overline grey--text mr-5">
                            {{ $t("rating3") }} :
                          </div>
                        </td>
                        <td class="pb-5">
                          <v-rating
                            dense
                            background-color="grey lighten-1"
                            color="light-blue"
                            hover
                            length="5"
                            readonly
                            v-model="review.rating3Avg"
                          ></v-rating>
                        </td>
                        <td class="pb-5">
                          <div class="overline grey--text mr-5">
                            {{ $t("rating4") }} :
                          </div>
                        </td>
                        <td class="pb-5">
                          <v-rating
                            dense
                            background-color="grey lighten-1"
                            color="light-blue"
                            hover
                            length="5"
                            readonly
                            v-model="review.rating4Avg"
                          ></v-rating>
                        </td>
                      </tr>
                      <tr>
                        <td class="pb-5">
                          <div class="overline grey--text mr-5">
                            {{ $t("rating5") }} :
                          </div>
                        </td>
                        <td class="pb-5">
                          <v-rating
                            dense
                            background-color="grey lighten-1"
                            color="light-blue"
                            hover
                            length="5"
                            readonly
                            v-model="review.rating5Avg"
                          ></v-rating>
                        </td>
                        <td class="pb-5">
                          <div class="overline grey--text mr-5">
                            {{ $t("rating6") }} :
                          </div>
                        </td>
                        <td class="pb-5">
                          <v-rating
                            dense
                            background-color="grey lighten-1"
                            color="light-blue"
                            hover
                            length="5"
                            readonly
                            v-model="review.rating6Avg"
                          ></v-rating>
                        </td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>
                <v-row>
                  <v-col cols="12" v-for="(items, i) in reviews" :key="i">
                    <v-divider></v-divider>
                    <v-list-item three-line>
                      <v-list-item-avatar size="60">
                        <img
                          :src="$store.state.baseUrl + items.user_id.profilePic"
                        />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <div class="subtitle-1 mb-0">
                          {{ items.user_id.firstName }}
                          {{ items.user_id.lastName }}
                        </div>
                        <div class="caption mb-2">
                          {{ format(new Date(items.dateCreated), "MMMM yyyy") }}
                        </div>
                        <p class="font-italic mb-0">{{ items.comments }}</p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-container>
      </div>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import VideoTourDialog from "@/components/listing/view/VideoTourDialog.vue";
import ListingService from "@/services/ListingService";
import PriceSectionComponent from "@/components/listing/view/PriceSectionComponent.vue";
import { format } from "date-fns";

export default {
  name: "GuestViewListing",
  components: {
    FullHeaderComponent,
    CopyrightComponent,
    PriceSectionComponent,
    VideoTourDialog
  },
  data() {
    return {
      format,
      list: null,
      review: null,
      reviews: [],
      parm: this.$route.params.id,
      video_url: [],
      videos: [],
      error: null,
      currency_code: this.$store.state.user.prefered_currency,
      basic_amenities: [],
      near_attractions: [],
      dialog: false,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    };
  },
  created: function() {
    ListingService.guestViewProperty({
      id: this.parm,
      prefered_currency: this.currency_code
    })
      .then(async ({ data: { item, review, reviews } }) => {
        let { pictures } = item;
        pictures.sort((a, b) => a.order - b.order);
        this.list = { ...item, pictures };
        this.review = review[0];
        this.reviews = reviews;
        if (this.list.video_url) {
          this.video_url = this.list.video_url;
        }
        if (this.list.videos) {
          this.videos = this.list.videos;
        }
        if (this.list.near_attractions) {
          this.near_attractions = this.list.near_attractions;
        }
        const amenities = this.list.amenities.reduce((r, a) => {
          const value = a["tag"];
          r[value] = (r[value] || []).concat(a);
          return r;
        }, {});
        this.basic_amenities = Object.entries(amenities).map(
          ([title, data]) => ({
            title,
            data
          })
        );
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {}
};
</script>

<style>
.cap {
  background: rgba(33, 150, 243, 0.7);
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 10px;
}
</style>
